import React from "react";

function FileUploadInFormDisplay({ data }) {
  return <div>User will be asked to upload file</div>;
}

export default FileUploadInFormDisplay;
